import React, { useEffect, useMemo, useState } from 'react';
import { translate } from '../../Services/translation';
import clsx from 'clsx';
const MAX_DESCRIPTION_LENGTH = 240;

const CategoryDescription = ({
  name,
  description,
  images,
}: {
  name: string;
  description: string;
  images: string[];
}) => {
  const [showMore, setShowMore] = useState(true);
  const descriptionLength = useMemo(
    () => description?.length,
    [description]
  );

  useEffect(() => {
    setShowMore(descriptionLength >= MAX_DESCRIPTION_LENGTH);
  }, [descriptionLength]);
  return (
    <div className="container flex flex-col-reverse gap-6 py-4 md:flex-row lg:py-6">
      <div className="flex w-full flex-1 flex-col justify-center gap-2">
        <div
          className={clsx(
            showMore ? 'max-h-28' : 'max-h-none',
            'relative flex flex-col gap-2 overflow-hidden'
          )}
        >
          {name && <h1 className="title">{name}</h1>}
          {description && <div className="text-lg">{description} </div>}
        </div>
        {descriptionLength >= MAX_DESCRIPTION_LENGTH && (
          <button
            className="btn btn--large btn--clear max-w-max p-0 font-normal normal-case underline hover:bg-transparent"
            onClick={() => setShowMore(!showMore)}
          >
            {!showMore
              ? translate('general.show-less')
              : translate('general.show-more')}
          </button>
        )}
      </div>
      {images && images.length >= 1 && (
        <div className="w-full flex-1 flex-col gap-2">
          <img
            className="max-h-[180px] w-full object-cover lg:max-h-[240px] xl:max-h-[320px]"
            src={images[0]}
            alt="category description image"
          />
        </div>
      )}
    </div>
  );
};

export default CategoryDescription;
